export const UnassignedLeadsText = "UNASSIGNED LEADS";
export const OpenLeadsText = "OPEN LEADS";
export const ClosedLeadsText = "CLOSED LEADS";
